

export class Queue<T> {
  _store: T[] = [];
  public push(val: T) {
    this._store.push(val);
  }
  public pop(): T | undefined {
    return this._store.shift();
  }
  public isEmpty(): boolean {
    return this._store.length === 0;
  }
}
